export default __webpack_public_path__ + "static/media/1905.46f88b94.png";